import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagsComponent } from './tags.component';
import {FormsModule} from '@angular/forms';
import { AvailableTagsComponent } from './available-tags/available-tags.component';
import { SingleTagComponent } from './single-tag/single-tag.component';
import { TagListComponent } from './tag-list/tag-list.component';
import { TaggedBaseComponent } from './tagged-base/tagged-base.component';
import {T} from '../../../node_modules/@angular/core/src/render3';

@NgModule({
  imports: [
    CommonModule,
      FormsModule
  ],
    exports: [TagsComponent, AvailableTagsComponent, SingleTagComponent, TagListComponent],
  declarations: [TagsComponent, AvailableTagsComponent, SingleTagComponent, TagListComponent]
})
export class TagsModule { }



// WEBPACK FOOTER //
// ./src/app/tags/tags.module.ts